<!-- Side panel style -->
<div *ngIf="isInternalRecord; else disabledBtn">
  <span class="text-neutral-900 fw-semibold cursor-pointer hover-underline" (click)="openSidepanel()">{{hasEvidences ?
    'View' : 'Add'}}
  </span>
</div>

<ng-template #disabledBtn>
  <span class="text-neutral-900 fw-semibold">
    - <ui-streamline-icon
      [slIcon]="{name: 'interface-alert-information-circle', theme: 'micro-bold', size: 'sm', color: 'default'}"
      ngbTooltip="Evidence can only be attached to Internal Records" [tooltipClass]="'custom-tooltip'"
      [placement]="'auto'" class="ms-1 cursor-pointer"></ui-streamline-icon>
  </span>
</ng-template>


<app-shared-sidebar #appSharedSidebar showHeaderUnderline="true" [isLoading]="isLoading" sidebarWidth="532px">
  <ng-container sideBarBodySlot *ngIf="!isLoading">
    <!-- compliance banner -->
    <div class="m-compliance-banner-container">
      <p class="m-label-text mb-2 text-align-center">Showing Evidence for</p>
      <div class="row">
        <p class="m-item-title col-5">{{activity.title || '-'}}</p>
        <p class="col-4">
          <staff-link-display *ngIf="user" [rowData]="user"
            textStyle="font-weight: 400 !important; font-size: 12px !important; color: #6F7786 !important;"></staff-link-display>
        </p>
        <div class="col d-flex justify-content-center align-items-center">
          <span class="badge {{complianceStatusBadgeStyle}}">{{activity.status || '-'}}</span>
        </div>
      </div>
    </div>

    <!-- evidence section -->
    <div class="p-4 m-sidepanel-section">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h4 class="fw-semibold mb-2">Evidence</h4>
        <app-download-certificate [rowData]="rowData"></app-download-certificate>
      </div>
      <!-- Add new evidence btn -->
      <div>
        <!-- Evidences sections -->
        <ng-container *ngIf="evidences; else emptyEvidence">
          <ng-container *ngFor="let evidence of evidences">
            <app-side-panel-evidence-section [evidence]="evidence"
              [context]="{orgActivityID: activity.activityID, user: user}"></app-side-panel-evidence-section>
          </ng-container>
        </ng-container>

        <ng-template #emptyEvidence>
          <p class="mb-2">No evidence to display</p>
        </ng-template>

        <button *ngIf="!hasAddEvidenceSection; else addEvidenceSection" class="btn btn-outline-light"
          (click)="showAddSection()" type="button">
          <span class="text-neutral-900 fw-semibold f-small">
            + Add Evidence
          </span>
        </button>

        <ng-template #addEvidenceSection>
          <div id="add-evidence-section-container">
            <app-add-evidence context="sidepanel" (evidenceFormChange)="evidenceFormValue = $event"
              (addEvidenceChange)="addEvidence($event)" (cancelStatusChange)="cancel()"></app-add-evidence>
          </div>
        </ng-template>
      </div>
    </div>
  </ng-container>
</app-shared-sidebar>
